/* istanbul ignore file -- api */
import { useEnvironment } from '@ori/environment';
import { useLanguage } from '@ori/i18n';
import { useGetTenantApplicationsFooter } from '@ori/static-api-client-react';

import { parseFooterData } from '../utils';

export const useGetFooterContent = () => {
  const { tenant } = useEnvironment();
  const { language } = useLanguage();
  const result = useGetTenantApplicationsFooter(
    tenant,
    {
      lang: language,
    },
    {
      swr: {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
      },
    },
  );

  return {
    ...result,
    data: result.data?.data ? parseFooterData(result.data.data) : null,
  };
};
